/*
* Created on Feb 24, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React from 'react';
import ic_nas_0b_t1_svg from '../../static/img/device/ic_nas_0b_t1.svg.svg';
import act_goto_svg from '../../static/img/utils/ic-goto.svg';
import ic_transfer_back_svg from '../../static/img/utils/ic-transfer-back.svg';
import {dataCellLabelToDataGridArea} from "../../service/utils";


const DeviceTableRowComponent = ({row_data, index, doRefresh, disPatcher, translate:t, isOwner, permissions=null, table_head_fields, state}) => {
    const hasPermission = state?.userPermissions?.hasPermission('manage_device', [row_data?.device_id]);

    const getFirmware = () => {
        const firmware = row_data.info;
        const firmware_version = firmware?.firmware_version ? `.${firmware.firmware_version}` : undefined;
        const firmware_number = firmware?.firmware_number ? `.${firmware.firmware_number}` : '';
        const build_number = firmware?.firmware_build_number ? `(${firmware.firmware_build_number})` : '';
        if (!firmware_version) {
            return '';
        }
        return `${firmware.firmware_version}${firmware_number} ${build_number}`;
    }

    return (
        <div className="flexbox-trow" key={index}>
            <div className="tbody-cell !w-15" data-cell-label={t(table_head_fields[0].field_name)} data-grid-area={dataCellLabelToDataGridArea(table_head_fields[0].field_name)}>
                <div className="device-name-group">
                    <div className="device-img !mr-8">
                        {row_data.model_info?.icon_url && <img src={row_data.model_info.icon_url} alt={''}/>}
                        {!row_data.model_info?.icon_url && <img src={ic_nas_0b_t1_svg} alt={''}/>}
                        {/*<img src={nas_03_svg} alt={''}/>*/}
                    </div>
                    <div className="device-name">{row_data.device_name}</div>
                    <div className="act-btn-group">
                        <div className="act-btn act-btn--goto" onClick={
                            () => window.open(`${window._env_.REACT_APP_QLINK_TO_URL}/${row_data.device_name}`, '_blank')
                        }>
                            <img src={act_goto_svg} alt=""/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="tbody-cell !w-12" data-cell-label={t(table_head_fields[1].field_name)} data-grid-area={dataCellLabelToDataGridArea(table_head_fields[1].field_name)}>{row_data.model_info?.name}</div>
            <div className="tbody-cell !w-14" data-cell-label={t(table_head_fields[2].field_name)} data-grid-area={dataCellLabelToDataGridArea(table_head_fields[2].field_name)}>{getFirmware()}</div>
            <div className="tbody-cell !w-10" data-cell-label={t(table_head_fields[3].field_name)} data-grid-area={dataCellLabelToDataGridArea(table_head_fields[3].field_name)}>{t(row_data?.organization_site_name)}</div>
            <div className="tbody-cell !w-14" data-cell-label={t(table_head_fields[4].field_name)} data-grid-area={dataCellLabelToDataGridArea(table_head_fields[4].field_name)}>{row_data.info?.hw_serial_number}</div>
            <div className="tbody-cell !w-20" data-cell-label={t(table_head_fields[5].field_name)} data-grid-area={dataCellLabelToDataGridArea(table_head_fields[5].field_name)}>
                <div className="tag-group">
                    {row_data?.user_whitelist?.tags.length > 0 && row_data?.user_whitelist?.tags.slice(0, 2).map((tag, index) => (
                        <span className="tag" key={index}>{tag}</span>))}
                    {row_data?.user_whitelist?.tags.length > 2 &&
                        <span className="tag tag-more">{`+ ${row_data?.user_whitelist?.tags.length - 2}`}</span>}
                    {!row_data?.transfer && hasPermission &&
                        <button className="q-btn q-btn-default q-btn-tiny q-btn-rounded-full tag-act--add"
                            onClick={() => disPatcher({
                                type: 'toggle_admin',
                                payload: {open: true, device_data: row_data}
                            })}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 5V15" stroke="#000" strokeWidth="1" strokeLinecap="round"
                                      strokeLinejoin="round"/>
                                <path d="M5 10H15" stroke="#000" strokeWidth="1" strokeLinecap="round"
                                      strokeLinejoin="round"/>
                            </svg>
                        </button>
                    }
                    {
                        row_data?.user_whitelist?.tags.length > 2 &&
                        <div className="popover read-only group-tooltip">
                            <ul className="popover-menu">
                                <li className="section">
                                    {
                                        row_data?.user_whitelist?.tags.map((name, idx) => <div className="section-items"
                                                                                               key={idx + name}>{name}</div>)
                                    }
                                </li>
                            </ul>
                        </div>
                    }
                </div>
            </div>
            <div className="tbody-cell !w-14" data-cell-label={t(table_head_fields[6].field_name)} data-grid-area={dataCellLabelToDataGridArea(table_head_fields[6].field_name)}>
                {row_data?.transfer &&
                    <div className="progress-indicator-group">
                        <div className="circle-progress-indicator tiny">
                            <svg className="circular" viewBox="0 0 40 40">
                                <circle className="base" cx="20" cy="20" r="16" fill="none" stroke-linecap="round" stroke-width="4" stroke-miterlimit="10" stroke="#e5e8eb"></circle>
                                <circle className="path" cx="20" cy="20" r="16" fill="none" stroke-linecap="round" stroke-width="4" stroke-miterlimit="10" stroke="#001b49"></circle>
                            </svg>
                        </div>
                        <div className="progress-label">{t('@Transferring@')}...</div>
                    </div>
                }
                {!row_data?.transfer && row_data?.source_user && hasPermission &&
                    <div className="cell-action-group">
                        <div className="cell-text">{row_data?.source_user?.display_name || '-'}</div>
                        <div className="act-btn-group" onClick={() => disPatcher({type: 'toggle_transfer', payload: {open: true, data: row_data, firmware: getFirmware()}})}>
                            <div className="act-btn act-btn--transer-back">
                                <img src={ic_transfer_back_svg} alt=""/>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
};

export default DeviceTableRowComponent;


/* determine device icon
this.model_info.device_show_img_url = null;
if (QCONFIG.china_site) {
    this.model_info.device_show_img_url = this.model_info.china_img_url;
    if (QCONFIG.ipv4 === false) {
        this.model_info.device_show_img_url = this.model_info.china_img_url_ipv6;
    }
} else {
    this.model_info.device_show_img_url = this.model_info.img_url;
    if (QCONFIG.ipv4 === false) {
        this.model_info.device_show_img_url = this.model_info.img_url_ipv6;
    }
}
 */